import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux'
import {
    Head,
    Tree,
    TicketCategoryCreate,
    TicketCategoryEdit,
    TicketCategoryMove
} from "../../../components";
import {Paper} from "@mui/material";
import {Tooltip} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

import { treeAction } from './../../../actions'
import {FETCH_NODES, TOGGLE_CHECKED, TOGGLE_EXPANDED} from "../../../types";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import {Link} from "react-router-dom";

const Category = ({fetchNodes, tree}) => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({type: TOGGLE_CHECKED, payload: []});
        dispatch({type: TOGGLE_EXPANDED, payload: []});
        dispatch({type: FETCH_NODES, payload: []});
        handleRequest();
    }, []);

    const handleRequest = () => {
        fetchNodes()
    }

    const expandScrolling = (expanded, nodes) => {

        nodes.map((node) => {
            expanded.push(node.id);
            expandScrolling(expanded,node.children);
        });

        return expanded;
    }

    const handleToggleExpand = () => {

        if (tree.expanded.length === 0) {
            dispatch({type: TOGGLE_EXPANDED, payload: expandScrolling(tree.expanded, tree.nodes) });
        } else {
            dispatch({type: TOGGLE_EXPANDED, payload: []});
        }

    }

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت دسته بندی تیکت ها', 'description': 'دسته بندی  را مدیریت نمایید.' }} />
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <TicketCategoryCreate checked={tree.checked} reload={() => handleRequest()} />
                {tree.checked.length === 1 && <TicketCategoryEdit checked={tree.checked} reload={() => handleRequest()} />}
                {tree.checked.length === 1 && <TicketCategoryMove checked={tree.checked} reload={() => handleRequest()} />}
                {tree.checked.length === 1 &&
                <Tooltip title="ایجاد راهنما">
                    <IconButton component={Link} to={'/ticket/category/faq'}>
                        <LiveHelpIcon />
                    </IconButton>
                </Tooltip>
                }
                <Tooltip title="باز و بسته کردن">
                    <IconButton onClick={() => handleToggleExpand()}>
                        <AspectRatioIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title="سینک">
                    <IconButton onClick={() => handleRequest()} >
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <Paper elevation={1}>
                <Tree nodes={tree.nodes} />
            </Paper>
        </Container>

    );
}


const mapStateToProps = state => ({
    tree: state.treeReducer
});

const mapDispatchToProps = (dispatch) => ({
    fetchNodes: () => {
        dispatch(treeAction.ticketCategories())
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Category)
